import * as _ from "lodash";
import { DEFAULT_PROSPECTS_FILTERS_SETTINGS } from "../data/DefaultSettings";
import { createSyncHandler } from "./createSyncHandler";
import { fetchHil, fetchHil2 } from "../utils";

export default {
  namespaced: true,
  state: {
    all: [],
    current: null,
    comments: [],
    commentsLoaded: false,
    previous: null
  },
  getters: {
    groupByProgress: state => {
      return _.groupBy(state.all, "currentProgress");
    }
  },
  mutations: {
    reset(state) {
      state.all = [];
    },

    setProspects(state, { prospects }) {
      // Sort by latest column change, oldest first
      state.all = _.sortBy(prospects, l =>
        _(l.progress)
          .values()
          .max()
      );
    },

    setProspect(state, prospect) {
      state.current = _.cloneDeep(prospect);
      state.comments = [];
      state.commentsLoaded = false;
      state.previous = _.cloneDeep(prospect);
    },

    setComments(state, comments) {
      state.comments = comments;
      state.commentsLoaded = true;
    },

    setSyncResults(state, { resp: prospect }) {
      state.current = _.cloneDeep(prospect);
      state.previous = _.cloneDeep(prospect);
    }
  },
  actions: {
    async resetProspects({ commit }) {
      commit("reset");
    },

    listProspects: _.debounce(async function listProspects(
      { commit },
      { filterSettings = DEFAULT_PROSPECTS_FILTERS_SETTINGS }
    ) {
      const queryString = new URLSearchParams(
        _.pickBy(
          {
            search: filterSettings.search,
            filter: filterSettings.filter
          },
          v => v !== undefined && v !== ""
        )
      );
      const resp = await (await fetchHil(`/prospects?${queryString}`)).json();
      commit("setProspects", { prospects: resp });
    },
    1000),

    async fetchProspect({ commit, dispatch }, { id }) {
      const resp = await (await fetchHil(`/prospects/${id}`)).json();
      await commit("setProspect", resp);
    },

    async saveProspect({ commit }, data) {
      const prospect = await fetchHil2("post", `/prospects`, {
        body: data
      });
      return prospect;
    },

    syncProspect: createSyncHandler(
      state => `/prospects/${state.current._id}`,
      "setSyncResults",
      [
        "_id",
        "userId",
        "tasks",
        "modelVersion",
        "lastProposal",
        "lastDispatch",
        "lastReport",
        "alerts",
        "__v",
        "progress",
        "isActive",
        "createdAt",
        "id",
        "stats",
        "leaseStats"
      ]
    )
  }
};
